import axios from 'axios';
import axiosRetry from 'axios-retry';
import getDataProps from '../hooks/useDataProps';

const { apiEndpoint } = getDataProps();

const axiosConfig = {
    baseURL: `${apiEndpoint}/`,
    credentials: 'include',
    timeout: 4000,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
};
const retryDelay = () => 1000;

const axiosInstance = axios.create({ ...axiosConfig });

axiosRetry(axiosInstance, { retries: 2, retryDelay });

export default axiosInstance